import styles from "./Styles/SideNav.module.css"
import React, { useState } from 'react'
import {AiFillHome} from "react-icons/ai"
import {FiBarChart2} from "react-icons/fi"
import {HiOutlineDocumentText, HiOutlineUser, HiSpeakerphone} from "react-icons/hi"
import {FaUserFriends} from "react-icons/fa"
import {MdIntegrationInstructions} from "react-icons/md"
import {IoMdSettings} from "react-icons/io"
import { useLocation, useNavigate } from "react-router-dom"
import { BsClipboardPlus } from "react-icons/bs"
import {TiDocumentText} from "react-icons/ti"

export default function SideNav() {
  const navigate = useNavigate()
  const location = useLocation()
  return (
    <nav className={styles.nav}>
        <ul>
            <li className={location.pathname.includes('leads/overview') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/overview')
            }}>
                <HiOutlineUser size={24} />
                <p>Overview</p>
            </li>
            <div className={styles.separator}></div>
            <li className={location.pathname.includes('leads/requirements') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/requirements')
            }}>
                <BsClipboardPlus size={24} />
                <p>Requirements</p>
            </li>
            <div className={styles.separator}></div>
            <li className={location.pathname.includes('leads/concepts') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/concepts')
            }}>
                <TiDocumentText size={24} />
                <p>Concepts</p>
            </li>
            <div className={styles.separator}></div>
            <li className={location.pathname.includes('leads/documents') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/documents')
            }}>
                <HiOutlineDocumentText size={24} />
                <p>Documents</p>
            </li>
            <div className={styles.separator}></div>
            <li className={location.pathname.includes('leads/boq') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/boq')
            }}>
                <TiDocumentText size={24} />
                <p>BOQ</p>
            </li>
            <div className={styles.separator}></div>
            <li className={location.pathname.includes('leads/records') ? styles.activeTab : ''} onClick={()=>{
                navigate('/dashboard/leads/records')
            }}>
                <TiDocumentText size={24} />
                <p>My Records</p>
            </li>
        </ul>
    </nav>
  )
}
